import { PermissionNames } from "../types/account.types"
import { SeoPagesConfig } from "../types/common.types"
import { RightElement, SettingsParentPage } from "./header.types"

export const NAVIGATION_ITEMS: any[] = [
  {
    route: '/shop',
    name: 'MARKET',
  },
  {
    route: '/pages/gift-cards',
    name: 'GIFT CARDS',
  },
  {
    route: '',
    name: 'FIND US',
    submenu: [
      {
        route: '/pages/atlanta-delivery-schedule',
        name: 'Atlanta Delivery Schedule'
      },
      {
        route: '/pages/directions-to-the-farm',
        name: 'Directions to the Farm'
      },
    ]
  },
  {
    route: '/pages/producers',
    name: 'PRODUCERS',
  },
  {
    route: '',
    name: 'ABOUT',
    submenu: [
      {
        route: '/pages/how-it-works',
        name: 'How it Works',
      },
      {
        route: '/pages/our-story',
        name: 'Our Story',
      },
      {
        route: 'pages/our-guiding-principles',
        name: 'Our Guiding Principles',
      },
      {
        route: 'pages/family-and-team',
        name: 'Family & Team',
      },
      {
        route: '/pages/products',
        name: 'Products',
      },
      {
        route: '/pages/faq',
        name: 'FAQ',
      }
    ]
  },
  {
    route: '/pages/blog',
    name: 'BLOG',
  },
  {
    route: '',
    name: 'FARM ACTIVITIES',
    submenu: [
      {
        route: '/pages/corn-maze',
        name: 'Corn Maze',
      },
      {
        route: '/pages/on-farm-store',
        name: 'On-Farm Store',
      },
      {
        route: '/pages/school-field-trips',
        name: 'School Field Trips',
      },
    ]
  },
  {
    route: '/pages/contact-us',
    name: 'CONTACT',
  }
]

export const SETTINGS_PAGES: SettingsParentPage[] = [
  {
    icon: 'account_circle',
    name: 'Account settings',
    children: [
      {
        route: '/settings/account/profile',
        name: 'Profile',
        permissionName: PermissionNames.settingsProfile
      },
      {
        route: '/settings/account/subscriptions',
        name: 'Subscriptions',
        permissionName: PermissionNames.settingsSubscription
      },
      {
        route: '/settings/account/deliveries',
        name: 'Deliveries',
        name2: 'Pick-Ups',
        permissionName: PermissionNames.settingsDeliveries
      },
      {
        route: '/settings/account/friend-referrals',
        name: 'Friend Referrals',
        permissionName: PermissionNames.settingsFriednReferrals
      },
    ],
    permissionName: PermissionNames.settings
  },
  {
    icon: 'credit_card',
    name: 'Billing settings',
    children: [
      {
        route: '/settings/billing/payment-method',
        name: 'Payment Method',
        permissionName: PermissionNames.settingsPaymentMethod
      },
      {
        route: '/settings/billing/membership',
        name: 'Membership',
        permissionName: PermissionNames.settingsMemebership
      },
      {
        route: '/settings/billing/order-and-billing',
        name: 'Order & Billing',
        permissionName: PermissionNames.settingsOrderHistory
      },
      {
        route: '/settings/billing/invoice-history',
        name: 'Invoice History',
        permissionName: PermissionNames.settingsInvoiceHistory
      },
    ],
    permissionName: PermissionNames.settings
  },
]

export const RIGHT_ELEMENTS: RightElement[] = [
  {
    tooltip: 'Favorites',
    route: '/favorites',
    icon: 'favorite',
    permissionName: PermissionNames.shop
  },
  {
    tooltip: 'Buy Again',
    route: '/buy-again',
    icon: 'verified',
    permissionName: PermissionNames.shop
  },
  {
    id: 'toggleCardPreviewNav',
    tooltip: 'Cart',
    route: '',
    icon: 'shopping_cart',
    showBadge: true,
    permissionName: PermissionNames.order,
    showWithoutPermission: true,
    shouldShowCartPreview: true
  },
]

export const SEO_PAGES_CONFIG: SeoPagesConfig = {
  howItWorks: {
    url: 'pages/how-it-works',
    title: 'How It Works'
  },
  ourStory: {
    url: 'pages/our-story',
    title: 'Our Story'
  },
  cornMaze: {
    url: '/pages/corn-maze',
    title: 'Corn Maze',
  },
  onFarmStore: {
    url: '/pages/on-farm-store',
    title: 'On-Farm Store',
  },
  schoolFieldTrips: {
    url: '/pages/school-field-trips',
    title: 'School Field Trips',
  },
  ourGuidingPrinciples: {
    url: 'pages/our-guiding-principles',
    title: 'Our Guiding Principles',
  },
  familyAndTem: {
    url: 'pages/family-and-team',
    title: 'Family & Team',
  },
  product: {
    url: '/pages/products',
    title: 'Products',
  },
  faq: {
    url: '/pages/faq',
    title: 'FAQ',
  },
  atlantaDeliverySchedule: {
    url: '/pages/atlanta-delivery-schedule',
    title: 'Atlanta Delivery Schedule'
  },
  directionsToFarm: {
    url: '/pages/directions-to-the-farm',
    title: 'Directions to the Farm'
  },
  producers: {
    url: '/pages/producers',
    title: 'Meet Our Producers'
  },
}
